import { DateTime } from "luxon";
import { Sparkles, AlertTriangle, Flame } from "lucide-react";

// Backend timestamps are naive ("2026-08-04T19:08:00", no Z/offset) but
// always UTC by this app's storage convention. Luxon's fromISO defaults an
// unmarked string to the *local* zone (same gotcha as JS `new Date(...)`),
// so an explicit string carrying its own offset/Z is left alone, and
// anything unmarked is parsed as UTC before converting to local for display.
export const formatUtcToLocal = (iso, fmt = "LLL d, yyyy") => {
  if (!iso) return "—";
  const hasZone = /[zZ]|[+-]\d{2}:?\d{2}$/.test(iso);
  const dt = hasZone ? DateTime.fromISO(iso) : DateTime.fromISO(iso, { zone: "utc" });
  return dt.toLocal().toFormat(fmt);
};

export const CATEGORY_META = {
  release_note: { label: "Release Note", icon: Sparkles, color: "#2563eb" },
  model_deprecation: { label: "Model Deprecation", icon: AlertTriangle, color: "#d97706" },
  emergency: { label: "Emergency", icon: Flame, color: "#dc2626" },
};

export const STATUS_META = {
  draft: { label: "Draft", color: "#6b7280" },
  scheduled: { label: "Scheduled", color: "#2563eb" },
  published: { label: "Published", color: "#16a34a" },
  archived: { label: "Archived", color: "#9ca3af" },
};

export const SEVERITY_META = {
  info: { label: "Info", color: "#6b7280" },
  warning: { label: "Warning", color: "#d97706" },
  critical: { label: "Critical", color: "#dc2626" },
};

export const pillStyle = (color) => ({
  // Soft tinted pill (no border), same look as the pills in the other tables
  background: `${color}1F`,
  color,
  borderRadius: "999px",
  padding: "0.25rem 0.75rem",
  fontSize: "0.75rem",
  fontWeight: 600,
  lineHeight: 1.4,
  whiteSpace: "nowrap",
  display: "inline-flex",
  alignItems: "center",
  gap: "0.35em",
});
